module.exports = {
  title: '工厂名片',
  route: {
    path: '/factory-trade-union',
    children: {
      path: 'factory-card-catalogue',
    },
  },
};
